import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  padding: 16px;
`;

export const ImageFromCollectionPlaceholder = () => (
  <Container data-cy="image-placeholder">
    No image to display. This element will not be shown in the published version.
  </Container>
);
